import { createFileRoute } from "@tanstack/react-router";
import { CountryChannelLanding } from "@/components/country/shared/CountryChannelLanding";

export const Route = createFileRoute("/mexico/televisa")({
  head: () => ({
    meta: [
      { title: "VerseSport México + Televisa Deportes — Segunda pantalla" },
      { name: "description", content: "Vive Televisa Deportes con VerseSport México: predicciones en vivo, ranking del Tri y Nation Wars." },
      { property: "og:title", content: "VerseSport México + Televisa Deportes" },
      { property: "og:description", content: "Predicciones y comunidad mientras ves Televisa Deportes." },
      { property: "og:url", content: "https://versesport.com/mexico/televisa" },
      { property: "og:type", content: "website" },
    ],
    links: [{ rel: "canonical", href: "https://versesport.com/mexico/televisa" }],
  }),
  component: () => (
    <CountryChannelLanding country="MX" channelId="televisa" intro="Acompaña Televisa Deportes con predicciones, ranking del Tri y comunidad mexicana." />
  ),
});